"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryCode = exports.Currency = void 0;
var Currency;

(function (Currency) {
  Currency["EUR"] = "EUR";
  Currency["GBP"] = "GBP";
  Currency["USD"] = "USD";
  Currency["CAD"] = "CAD";
  Currency["AUD"] = "AUD";
  Currency["JPY"] = "JPY";
  Currency["CHF"] = "CHF";
})(Currency = exports.Currency || (exports.Currency = {}));

var CountryCode;

(function (CountryCode) {
  CountryCode["GB"] = "GB";
  CountryCode["US"] = "US";
  CountryCode["CA"] = "CA";
  CountryCode["AU"] = "AU";
  CountryCode["JP"] = "JP";
  CountryCode["CH"] = "CH";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));